// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LocalPackSection {
  padding-top: 2rem;
  position: relative; }
  .LocalPackSection .header {
    display: flex;
    align-items: center;
    gap: 2rem;
    padding: 3rem 0; }
    .LocalPackSection .header .titleContainer {
      display: flex;
      align-items: center;
      gap: 2rem; }
      .LocalPackSection .header .titleContainer .title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #202124;
        font-size: 28px;
        line-height: 33px;
        font-weight: normal; }
      .LocalPackSection .header .titleContainer .menuBtn {
        font-size: 1.5rem; }
  .LocalPackSection .details {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-self: start;
    gap: 2rem; }
    .LocalPackSection .details iframe {
      border: none;
      border-radius: 1rem;
      height: 45rem; }
    .LocalPackSection .details .moreBtn {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      left: -2.9rem;
      margin: 0 auto;
      font-size: 14px;
      font-family: Roboto, arial, sans-serif;
      font-weight: 400;
      width: 100%;
      max-width: 300px;
      height: 30px;
      border-radius: 18px;
      background-color: #dedede;
      top: -1.3rem;
      color: #202124;
      cursor: pointer; }
      .LocalPackSection .details .moreBtn button {
        background-color: transparent;
        border: none;
        font-size: 1.4rem; }
      .LocalPackSection .details .moreBtn i {
        color: #70757a; }
    .LocalPackSection .details .cardContainer {
      width: 60%; }
      .LocalPackSection .details .cardContainer .sponsoredInfo {
        display: flex;
        align-items: center;
        gap: 1rem; }
        .LocalPackSection .details .cardContainer .sponsoredInfo .businessName {
          font-size: 2rem;
          color: #202124;
          line-height: 2rem; }
      .LocalPackSection .details .cardContainer .googleGuaranteed {
        display: flex;
        align-items: center;
        gap: 0.5rem; }
        .LocalPackSection .details .cardContainer .googleGuaranteed .googleGuaranteedText {
          text-transform: uppercase;
          font-size: 1.4rem;
          margin: 1rem 0;
          letter-spacing: 1px; }
      .LocalPackSection .details .cardContainer .locaPackCard {
        width: 100%; }
        .LocalPackSection .details .cardContainer .locaPackCard .moreBtn {
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          left: -2.9rem;
          margin: 0 auto;
          font-size: 14px;
          font-family: Roboto, arial, sans-serif;
          font-weight: 400;
          width: 100%;
          max-width: 300px;
          height: 30px;
          border-radius: 18px;
          background-color: #dedede;
          top: -1.3rem;
          color: #202124;
          cursor: pointer; }
          .LocalPackSection .details .cardContainer .locaPackCard .moreBtn button {
            background-color: transparent;
            border: none;
            font-size: 1.4rem; }
          .LocalPackSection .details .cardContainer .locaPackCard .moreBtn i {
            color: #70757a; }
    .LocalPackSection .details .dropdownData {
      display: flex;
      align-items: center;
      gap: 1rem; }
    .LocalPackSection .details .map {
      width: 60%;
      border-radius: 1rem;
      border: none; }
  .LocalPackSection.flex-row .details {
    display: flex;
    flex-direction: row-reverse;
    align-items: flex-start;
    justify-self: flex-start;
    gap: 2rem;
    justify-content: flex-end;
    width: 95%; }
    .LocalPackSection.flex-row .details .cardContainer {
      width: 60%; }
      .LocalPackSection.flex-row .details .cardContainer .locaPackCard {
        width: 90%; }
    .LocalPackSection.flex-row .details .map {
      width: 100%;
      transition: width 0.3s ease;
      /* Smooth width transition */ }
      .LocalPackSection.flex-row .details .map .i4ewOd-pzNkMb-haAclf {
        background-color: red; }
  .LocalPackSection.flex-row .dropdownData {
    position: absolute;
    left: 14%;
    top: 6.5%; }
  .LocalPackSection.flex-row .moreBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    left: -2.9rem;
    margin: 0 auto;
    font-size: 14px;
    font-family: Roboto, arial, sans-serif;
    font-weight: 400;
    width: 100%;
    max-width: 300px;
    height: 30px;
    border-radius: 18px;
    background-color: #dedede;
    top: -1.3rem;
    color: #202124;
    cursor: pointer; }
    .LocalPackSection.flex-row .moreBtn button {
      background-color: transparent;
      border: none;
      font-size: 1.4rem; }
    .LocalPackSection.flex-row .moreBtn i {
      color: #70757a; }
`, "",{"version":3,"sources":["webpack://./src/components/LocalPack/LocalPack.scss"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB,EAAA;EAFpB;IAII,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe,EAAA;IAPnB;MASM,aAAa;MACb,mBAAmB;MACnB,SAAS,EAAA;MAXf;QAaQ,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;QACnB,cAAc;QACd,eAAe;QACf,iBAAiB;QACjB,mBAAmB,EAAA;MAnB3B;QAsBQ,iBAAiB,EAAA;EAtBzB;IA2BI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS,EAAA;IA/Bb;MAiCM,YAAY;MACZ,mBAAmB;MACnB,aAAa,EAAA;IAnCnB;MAsCM,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,kBAAkB;MAClB,aAAa;MACb,cAAc;MACd,eAAe;MACf,sCAAsC;MACtC,gBAAgB;MAChB,WAAW;MACX,gBAAgB;MAChB,YAAY;MACZ,mBAAmB;MACnB,yBAAyB;MACzB,YAAY;MACZ,cAAc;MACd,eAAe,EAAA;MAtDrB;QAwDQ,6BAA6B;QAC7B,YAAY;QACZ,iBAAiB,EAAA;MA1DzB;QA6DQ,cAAc,EAAA;IA7DtB;MAiEM,UAAU,EAAA;MAjEhB;QAoEQ,aAAa;QACb,mBAAmB;QACnB,SAAS,EAAA;QAtEjB;UAwEU,eAAe;UACf,cAAc;UACd,iBAAiB,EAAA;MA1E3B;QA8EQ,aAAa;QACb,mBAAmB;QACnB,WAAW,EAAA;QAhFnB;UAkFU,yBAAyB;UACzB,iBAAiB;UACjB,cAAc;UACd,mBAAmB,EAAA;MArF7B;QAyFQ,WAAW,EAAA;QAzFnB;UA4FU,aAAa;UACb,mBAAmB;UACnB,uBAAuB;UACvB,kBAAkB;UAClB,aAAa;UACb,cAAc;UACd,eAAe;UACf,sCAAsC;UACtC,gBAAgB;UAChB,WAAW;UACX,gBAAgB;UAChB,YAAY;UACZ,mBAAmB;UACnB,yBAAyB;UACzB,YAAY;UACZ,cAAc;UACd,eAAe,EAAA;UA5GzB;YA+GY,6BAA6B;YAC7B,YAAY;YACZ,iBAAiB,EAAA;UAjH7B;YAoHY,cAAc,EAAA;IApH1B;MA0HM,aAAa;MACb,mBAAmB;MACnB,SAAS,EAAA;IA5Hf;MAgIM,UAAU;MACV,mBAAmB;MACnB,YAAY,EAAA;EAlIlB;IAwIM,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,wBAAwB;IACxB,SAAS;IACT,yBAAyB;IACzB,UAAU,EAAA;IA9IhB;MAiJQ,UAAU,EAAA;MAjJlB;QAoJU,UAAU,EAAA;IApJpB;MAwJQ,WAAW;MACX,2BAA2B;MAAE,4BAAA,EAA6B;MAzJlE;QA2JU,qBAAqB,EAAA;EA3J/B;IAgKM,kBAAkB;IAClB,SAAS;IACT,SAAS,EAAA;EAlKf;IAqKM,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,eAAe;IACf,sCAAsC;IACtC,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,cAAc;IACd,eAAe,EAAA;IArLrB;MAuLQ,6BAA6B;MAC7B,YAAY;MACZ,iBAAiB,EAAA;IAzLzB;MA4LQ,cAAc,EAAA","sourcesContent":[".LocalPackSection {\n  padding-top: 2rem;\n  position: relative;\n  .header {\n    display: flex;\n    align-items: center;\n    gap: 2rem;\n    padding: 3rem 0;\n    .titleContainer {\n      display: flex;\n      align-items: center;\n      gap: 2rem;\n      .title {\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        color: #202124;\n        font-size: 28px;\n        line-height: 33px;\n        font-weight: normal;\n      }\n      .menuBtn {\n        font-size: 1.5rem;\n      }\n    }\n  }\n  .details {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-self: start;\n    gap: 2rem;\n    iframe {\n      border: none;\n      border-radius: 1rem;\n      height: 45rem;\n    }\n    .moreBtn {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      position: relative;\n      left: -2.9rem;\n      margin: 0 auto;\n      font-size: 14px;\n      font-family: Roboto, arial, sans-serif;\n      font-weight: 400;\n      width: 100%;\n      max-width: 300px;\n      height: 30px;\n      border-radius: 18px;\n      background-color: #dedede;\n      top: -1.3rem;\n      color: #202124;\n      cursor: pointer;\n      button {\n        background-color: transparent;\n        border: none;\n        font-size: 1.4rem;\n      }\n      i {\n        color: #70757a;\n      }\n    }\n    .cardContainer {\n      width: 60%;\n\n      .sponsoredInfo {\n        display: flex;\n        align-items: center;\n        gap: 1rem;\n        .businessName {\n          font-size: 2rem;\n          color: #202124;\n          line-height: 2rem;\n        }\n      }\n      .googleGuaranteed {\n        display: flex;\n        align-items: center;\n        gap: 0.5rem;\n        .googleGuaranteedText {\n          text-transform: uppercase;\n          font-size: 1.4rem;\n          margin: 1rem 0;\n          letter-spacing: 1px;\n        }\n      }\n      .locaPackCard {\n        width: 100%;\n\n        .moreBtn {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          position: relative;\n          left: -2.9rem;\n          margin: 0 auto;\n          font-size: 14px;\n          font-family: Roboto, arial, sans-serif;\n          font-weight: 400;\n          width: 100%;\n          max-width: 300px;\n          height: 30px;\n          border-radius: 18px;\n          background-color: #dedede;\n          top: -1.3rem;\n          color: #202124;\n          cursor: pointer;\n\n          button {\n            background-color: transparent;\n            border: none;\n            font-size: 1.4rem;\n          }\n          i {\n            color: #70757a;\n          }\n        }\n      }\n    }\n    .dropdownData {\n      display: flex;\n      align-items: center;\n      gap: 1rem;\n    }\n\n    .map {\n      width: 60%;\n      border-radius: 1rem;\n      border: none;\n      // height: 400px;\n    }\n  }\n  &.flex-row {\n    .details {\n      display: flex;\n      flex-direction: row-reverse;\n      align-items: flex-start;\n      justify-self: flex-start;\n      gap: 2rem;\n      justify-content: flex-end;\n      width: 95%;\n\n      .cardContainer {\n        width: 60%;\n\n        .locaPackCard {\n          width: 90%;\n        }\n      }\n      .map {\n        width: 100%;\n        transition: width 0.3s ease; /* Smooth width transition */\n        .i4ewOd-pzNkMb-haAclf {\n          background-color: red;\n        }\n      }\n    }\n    .dropdownData {\n      position: absolute;\n      left: 14%;\n      top: 6.5%;\n    }\n    .moreBtn {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      position: relative;\n      left: -2.9rem;\n      margin: 0 auto;\n      font-size: 14px;\n      font-family: Roboto, arial, sans-serif;\n      font-weight: 400;\n      width: 100%;\n      max-width: 300px;\n      height: 30px;\n      border-radius: 18px;\n      background-color: #dedede;\n      top: -1.3rem;\n      color: #202124;\n      cursor: pointer;\n      button {\n        background-color: transparent;\n        border: none;\n        font-size: 1.4rem;\n      }\n      i {\n        color: #70757a;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
